import { createApp } from 'vue'
import Logaritma from './Logaritma.vue'
import './assets/global.css'

createApp(Logaritma).mount('#logaritma')
